/* jshint esversion: 6 */

import axios from 'axios';

const microserviceUrl = process.env.VUE_APP_ONBOARDING_WEBAPI_URL;
//const microserviceUrl = "http://localhost:55242";

export function getPromiseGet(options) {
    return new Promise((resolve, reject) => {
        axios.get(options.url, { withCredentials: options.withCredentials })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function getPromisePost(options) {
    return new Promise((resolve, reject) => {
        axios.post(options.url, options.params, { withCredentials: options.withCredentials })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function getWidgets(touchpointType, touchpointCode, count) {
    const url = `${microserviceUrl}/Widgets/get_info_by_touch_point`;
    const options = {
        url: url,
        withCredentials: true,
        params: {
            touchpointType: touchpointType,
            touchpointCode: touchpointCode,
            count: count
        }
    };

    return getPromisePost(options);
}

export function getUserInfo() {
    const url = `${microserviceUrl}/Widgets/get-user-info`;
    const options = {
        url: url,
        withCredentials: true
    };

    return getPromisePost(options);
}

export function getJobDuties() {
    const url = `${microserviceUrl}/Widgets/get-job-duties`;
    const options = {
        url: url,
        withCredentials: true
    };

    return getPromisePost(options);
}

export function getWidgetAny(magnetCode, touchpointType, touchpointCode, count, profitUrl = null) {
    const url = `${microserviceUrl}/Widgets/get_info_by_touch_point`;
    //const url = `http://localhost:55242/Widgets/get_info_by_touch_point`;
    const options = {
        url: url,
        withCredentials: true,
        params: {
            magnetCode: magnetCode,
            touchpointType: touchpointType,
            touchpointCode: touchpointCode,
            count,
            profitUrl: profitUrl
        }
    };

    return getPromisePost(options);
}

export function getWidgetsDetail(touchpointType, touchpointCode, touchpointItemCode) {
    const url = `${microserviceUrl}/Widgets/get_info_by_touch_point`;
    const options = {
        url: url,
        withCredentials: true,
        params: {
            touchpointType: touchpointType,
            touchpointCode: touchpointCode,
            touchpointItemCode: touchpointItemCode
        }
    };

    return getPromisePost(options);
}

export function getWidgetsOnboarding(params) {
    const url = `${microserviceUrl}/Widgets/get_onboarding`;
    const options = {
        url: url,
        withCredentials: true,
        params: params
    };

    return getPromisePost(options);
}

export function tryConfirmCustomerMagnet(params) {
    const url = `${microserviceUrl}/Widgets/try_confirm_customer_magnet`;
    const options = {
        url: url,
        withCredentials: true,
        params: params
    };

    return getPromisePost(options);
}

export function findWidgetByProfit(widgets, profitCode) {
    return widgets.findIndex((el, index, array) => {
        if (array.length == 1 && el.targetCode === 'REG_LOGIN') return true;
        return el.positionCode === profitCode;
    });
}

export function showAdvertising(item, index, items) {

    //не показывать если нет элементов
    if (!items || items.length <= 0) return false;
    //не показывать если это последний элемент
    if (items.length - 1 === index) return false;

    if (items.length >= 2 && items.length <= 4) {
        const showIndex = items.length - 2;
        // this.run();
        if (index === showIndex) return true;
    } else {
        const number = index + 1;
        if (number % 4 == 0) return true;
    }

    return false;
}

//выдача

export function getWidgetIndex(index, length = 0) {
    const quantity = length;

    if (quantity <= 0 && index + 1 % 4 == 0) return -1;

    let widgetIndex = (index + 1) / 4 - 1;

    widgetIndex = widgetIndex >= quantity ? -1 : widgetIndex;

    return widgetIndex;

}

export function getReachedUserMagnets(touchpointType, touchpointCode, touchpointItemCode, magnetCode) {
    const url = `${microserviceUrl}/Widgets/get_reached_customer_magnets`;
    const options = {
        url: url,
        withCredentials: true,
        params: {
            touchPointType: touchpointType,
            touchPointCode: touchpointCode,
            touchPointItemCode: touchpointItemCode,
            magnetCode: magnetCode
        }
    };

    return getPromisePost(options);
}

export function getMagnetsSettings(touchpointType, touchpointCode, touchpointItemCode, magnetCode, profitCode) {
    const url = `${microserviceUrl}/Widgets/get_magnet_settings`;
    const options = {
        url: url,
        withCredentials: true,
        params: {
            touchPointType: touchpointType,
            touchPointCode: touchpointCode,
            touchPointItemCode: touchpointItemCode,
            magnetCode: magnetCode,
            profitCode: profitCode
        }
    };

    return getPromisePost(options);
}

export function parseUrlQuery() {
    const data = {};
    if (window.location.search) {
        const pair = (window.location.search.substr(1)).split('&');
        for (let i = 0; i < pair.length; i++) {
            const param = pair[i].split('=');
            data[param[0]] = param[1];
        }
    }
    return data;
}